module.exports = __webpack_public_path__ + "public/SideMenuIcons/mangeCategory.svg?ae057551";